module.exports = __webpack_public_path__ + "img/solution-msil-system-pic-1.e6832312.png";